import { render, staticRenderFns } from "./UspSection.vue?vue&type=template&id=227b5588&"
import script from "./UspSection.vue?vue&type=script&lang=js&"
export * from "./UspSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports